/*------------------------------------------------
// File Name:PDM_MA_PatientInfo.js
// File Description:PDM_MA_PatientInfo store方法
// Author:zxl
// Create Time:2023/07/10 17:29:38
//------------------------------------------------*/

import {
    GetPDM_MA_PatientInfoList,
    GetPDM_MA_PatientInfoListByPage,
    GetPDM_MA_PatientInfoEntity,
    CreatePDM_MA_PatientInfoEntity,
    UpdatePDM_MA_PatientInfoEntity,
    DeletePDM_MA_PatientInfoEntity,
} from '@/api/pdm/ma/maPatientinfo'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaPatientinfo = {
    namespaced: true,
    state: {
        PdmMaPatientinfoList: [],
        PdmMaPatientinfoListLoading: false,
        PdmMaPatientinfoEntity: null,
        PdmMaPatientinfoShowDlg: false,
        MaPathShowDlg: false,
    },
    mutations: {
        setPdmMaPatientinfoList(state, dataList) {
            state.PdmMaPatientinfoList = [...dataList]
        },
        setPdmMaPatientinfoListLoading(state, visible) {
            state.PdmMaPatientinfoListLoading = visible
        },
        setMaPathShowDlg(state, visible) {
            state.MaPathShowDlg = visible
        },
        setPdmMaPatientinfoShowDlg(state, visible) {
            state.PdmMaPatientinfoShowDlg = visible
        },
        setPdmMaPatientinfoEntity(state, entity) {
            state.PdmMaPatientinfoEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmMaPatientinfo({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_PatientInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPatientinfoEntity', res.Data)
                        commit('setPdmMaPatientinfoShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmMaPatientinfoEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPatientinfoListLoading', true)
                GetPDM_MA_PatientInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPatientinfoEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPatientinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmMaPatientinfoList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPatientinfoListLoading', true)
                GetPDM_MA_PatientInfoList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPatientinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPatientinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmMaPatientinfoListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPatientinfoListLoading', true)
                GetPDM_MA_PatientInfoListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPatientinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPatientinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmMaPatientinfo({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_PatientInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPatientinfoShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_PatientInfo
        actEditPdmMaPatientinfoData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaPatientinfoID : entity.PdmMaPatientinfoID
                }
                GetPDM_MA_PatientInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaPatientinfoEntity', res.Data)
                        commit('setPdmMaPatientinfoShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_PatientInfo ,传对象过来
        actEditPdmMaPatientinfo({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaPatientinfoEntity', entity)
                commit('setPdmMaPatientinfoShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_PatientInfo
        actDeletePdmMaPatientinfo({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_MA_PatientInfoEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaPatientinfoShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


